export default [
  {
    path: '/smartLocker',
    component: () => import('@/components/Layer.vue'),
    children: [
      {
        path: '/smartLocker/',
        name: 'smartLockerManagement',
        component: () => import('@/views/SmartLocker/smartLockerManagement.vue'),
        children: [
          {
            path: '',
            redirect: { name: 'pendingList' }
          },
          {
            path: 'pendingList',
            name: 'pendingList',
            component: () => import('@/views/SmartLocker/pendingList.vue'),
            meta: {
              prev: 'goHome'
            }
          },
          {
            path: 'lockerStatus',
            name: 'lockerStatus',
            component: () => import('@/views/SmartLocker/lockerStatus.vue'),
            meta: {
              prev: 'goHome'
            }
          }
        ]
      }
    ]
  }
]
